import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  return <section aria-labelledby="reviews-heading" className="topo-light w-full bg-paper text-pine" data-id="element-252" data-mp="2hddqdrytf86q">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-253" data-mp="2madv9zjxi4w9">
        <div className="text-center" data-id="element-254" data-mp="2rb1v9aq4xw2m">
          <p className="eyebrow text-ember-deep" data-id="element-255" data-mp="2rc3a7qa9v2pm">From the field</p>
          <h2 id="reviews-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-256" data-mp="2w8toc82ino8e">
            What coaches are seeing with their groups
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-257" data-mp="352yip1guzhso">
            Outdoor coaches and instructors in Canada, the UK and the US using
            Troop Night Ready with their groups.
          </p>
        </div>

        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-258" data-mp="3jz7ic44nvx5m">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-259" data-mp="2rcxgt6iu31um">
              <figure className="flex w-full flex-col border-t-2 border-ember pt-5" data-id="element-260" data-mp="2raktsey7y1ap">
                <blockquote className="text-[17px] leading-relaxed text-pine" data-id="element-261" data-mp="2mc9hzyod5gpu">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-262" data-mp="2dd5zowx0t5ce">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-display text-sm text-paper" data-id="element-263" data-mp="2df8tls1anime">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-pine-soft" data-id="element-264" data-mp="30azd58rmh6bk">
                    <span className="block text-[14px] font-bold text-pine" data-id="element-265" data-mp="2wb8rfjgydgdw">
                      {review.name}
                    </span>
                    {review.role}
                    <span className="mt-0.5 flex items-center gap-1 text-pine-muted" data-id="element-266" data-mp="3o2o9d07keexs">
                      <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-267" data-mp="1m4unhhkw5r0f" />
                      {review.city}, {review.country}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}